export const TESTKUBE_ORGANIZATION = 'testkube.io/organization';
export const TESTKUBE_ENVIRONMENTS = 'testkube.io/environments';
export const TESTKUBE_LABELS = 'testkube.io/labels';
